jQuery(document).ready(function ($) {
  // jQuery + Slick must be loaded once
  document.querySelectorAll('.portfolio-slider-wrap .portfolio-slider').forEach(function (el) {
    $(el).slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true, // finite (left → right)
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 600,
      cssEase: 'ease',
      swipeToSlide: true,
      arrows: false,
      dots: true,
      pauseOnHover: true,
      // Keep a peek on smaller screens too
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 1 } },
      ],
    });
  });
});
